"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.CarouselSkeleton = exports.ButtonSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _TitleSkeleton = require("../TitleSkeleton");
const CarouselSkeleton = exports.CarouselSkeleton = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'grid',
        gap: theme.spacing(2),
        gridTemplateColumns: "repeat(6, ".concat(_presentationComponents.EDITORIAL_CAROUSEL_SLIDE_MOBILE_MIN_WIDTH, "px)"),
        overflow: 'hidden',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(10),
            gridTemplateColumns: "repeat(6, ".concat(_presentationComponents.ARTICLE_BOX_DESKTOP_WIDTH, "px)")
        }
    };
});
const Title = exports.Title = (0, _mui.styled)(_TitleSkeleton.TitleSkeleton)((param)=>{
    let { theme } = param;
    return {
        marginBottom: 0,
        [theme.breakpoints.up('sm')]: {
            marginBottom: 0
        }
    };
});
const ButtonSkeleton = exports.ButtonSkeleton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        height: 45,
        width: 110,
        borderRadius: theme.spacing(5),
        margin: theme.spacing(0, 'auto')
    };
});
